export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getMediaBaseUrl = () =>
  (API_BASE_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '');

export const buildMediaUrl = (path = '') => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getMediaBaseUrl()}${normalizedPath}`;
};

export const API_ROUTES = {
  GET_USER_DETAILS: {
    METHOD: 'GET',
    URL: 'user',
  },
  GET_ADMIN_DETAILS: {
    METHOD: 'GET',
    URL: 'admin',
  },
  // Per-user interface state. Both calls append /:preference_key.
  GET_USER_PREFERENCE: {
    METHOD: 'GET',
    URL: 'user-preference',
  },
  SAVE_USER_PREFERENCE: {
    METHOD: 'PUT',
    URL: 'user-preference',
  },
};
